import { request } from './request'

export interface AdminPrinter {
  id: string
  name: string
  storeIds: string
  storeNames: string
  deviceKey?: string
  status?: string
  printScope?: string
  lastHeartbeatAt?: string
  createdAt?: string
}

export interface PrinterSavePayload {
  id?: string
  name: string
  storeIds?: string
  bindCode?: string
  status?: string
}

export const printerApiReady = true as const

export const fetchPrinters = async (): Promise<AdminPrinter[]> =>
  request<AdminPrinter[]>({
    url: '/printers',
    method: 'GET',
  })

export const createPrinter = async (payload: PrinterSavePayload): Promise<void> =>
  request<void, PrinterSavePayload>({
    url: '/printers',
    method: 'POST',
    data: payload,
  })

export const updatePrinter = async (payload: PrinterSavePayload): Promise<void> =>
  request<void, PrinterSavePayload>({
    url: '/printers',
    method: 'PUT',
    data: payload,
  })

export const deletePrinter = async (id: string): Promise<void> =>
  request<void>({
    url: `/printers/${id}`,
    method: 'DELETE',
  })
